export default __webpack_public_path__ + "static/media/avatar-s-1.d383013d.jpg";